<template>
  <layout-content>
    <settings-form />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';
  import SettingsForm from '@verification/components/settings-form';

  export default {
    components: { SettingsForm },

    methods: {
      ...mapActions('verification/sip-trunks/table', ['getAsyncData'])
    }
  };
</script>
